
import api from "../../../common/dependencies/utils/Api";
import {
 
  REGISTER_STARTUP_COHORT
} from "../../../common/constants/ApplicationUrl";

export const GetMentorFormServices = {
 
  registerStartupCohort(params) {
    //

    return api.POSTDATA(REGISTER_STARTUP_COHORT, params).then((response) => {
      //
      return response;
    });
  },
};
